module.exports = __webpack_public_path__ + "img/guzheng1.6fcf7cf9.png";